import Button from "./ds/Button";
import Icon from "./ds/Icon";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getDiscoverMintSpaces } from "../api/mintSpace";
import { useTranslation } from "../context/TranslationContext";
import { useImageLoader } from "../hooks/useImageLoader";
import SelectCampaignMintSpace from "./SelectCampaignMintSpace";
import CreateMintSpacePage from "../pages/CreateMintSpacePage";

const CreateBusinessWindow = ({ isDark, setToast }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const isNew = searchParams.get("new") === "1";
  const [mintSpaces, setMintSpaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);
  const { imagesLoaded } = useImageLoader(containerRef);

  useEffect(() => {
    const fetchMintSpaces = async () => {
      try {
        // The Discover list, because these cards show what a space card shows.
        const result = await getDiscoverMintSpaces("", "all", { mine: true });
        if (result.success && result.data) {
          setMintSpaces(result.data.map((space) => ({ ...space, isOwner: true })));
        }
      } catch {
        setMintSpaces([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMintSpaces();
  }, []);

  const handleSuccess = (mintSpaceData) => {
    window.dispatchEvent(new CustomEvent("mintSpaceCreated", { detail: mintSpaceData }));
    navigate(`/mint-space/${mintSpaceData._id}?nav=home`);
  };

  const mutedText = "text-label-secondary";

  if (loading || !imagesLoaded) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-center">
          <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-accent-default border-r-transparent" />
          <div className={`text-lg ${mutedText}`}>{t("windows.loading") || "Loading..."}</div>
        </div>
      </div>
    );
  }

  if (isNew) {
    return (
      <div className="mx-auto flex h-full w-full max-w-[1112px] flex-col gap-space-16 overflow-hidden p-space-16 font-ds lg:p-space-24">
        <Button
          variant="plain"
          size="s"
          className="self-start"
          icon={<Icon name="chevron-left" size={16} />}
          onClick={() => navigate("/create-business")}
        >
          {t("sidebar.yourBusinesses")}
        </Button>
        <CreateMintSpacePage isDark={isDark} setToast={setToast} onSuccess={handleSuccess} />
      </div>
    );
  }

  return (
    <div ref={containerRef} className="h-full w-full">
      <div className="campaign-window-scrollbar h-full overflow-y-auto">
        <div className="mx-auto w-full max-w-[1112px] p-space-16 lg:p-space-24">
          <SelectCampaignMintSpace
            variant="business"
            isDark={isDark}
            mintSpaces={mintSpaces}
            loading={false}
            onSelectSpace={(spaceId) => navigate(`/mint-space/${spaceId}?nav=home`)}
            onCreateBusiness={() => navigate("/create-business?new=1")}
            t={t}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateBusinessWindow;
